'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _doctifyUtils = require('doctify-utils');

require('../../src/styles/external.scss');

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _dropdown = require('dropdown');

var _reactDates = require('react-dates');

var _searchButton = require('./search-button');

var _subBarDropdown = require('./sub-bar-dropdown');

var _specialtySvgIcon = require('../../../specialty-svg-icon');

var _isInclusivelyAfterDay = require('react-dates/src/utils/isInclusivelyAfterDay');

var _isInclusivelyAfterDay2 = _interopRequireDefault(_isInclusivelyAfterDay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FOURTEEN = 14; //flow

var SEVEN = 7;
var ONE = 1;
var TWO = 2;
var APPOINTMENTS = 'appointments';
var HEALTH_CHECKS = 'healthChecks';
var SCANS = 'scans';

var timeFrameInterval = function timeFrameInterval(timeString) {
  switch (timeString) {
    case 'thisWeek':
      return [new _moment2.default().add(2, 'days'), new _moment2.default().add(SEVEN, 'days')];
    case 'twoWeeks':
      return [new _moment2.default().add(2, 'days'), new _moment2.default().add(FOURTEEN, 'days')];
    case 'today':
      return [new _moment2.default(), new _moment2.default().add(ONE, 'day')];
    case 'tomorrow':
      return [new _moment2.default().add(ONE, 'day'), new _moment2.default().add(TWO, 'days')];
    default:
      return null;
  }
};

var buildFoundResultsString = function buildFoundResultsString(_ref) {
  var resultCount = _ref.resultCount,
      selectedKeyword = _ref.selectedKeyword,
      selectedInsurer = _ref.selectedInsurer,
      selectedLocation = _ref.selectedLocation;

  var string = 'Found ' + resultCount + ' results';
  string += selectedKeyword && selectedKeyword.name && ' for ' + selectedKeyword.name || '';
  string += selectedInsurer && selectedInsurer.name && ' with ' + selectedInsurer.name + ' hospital list' || '';
  string += selectedLocation && selectedLocation.name && ' in ' + selectedLocation.name || '';

  string += '.';
  return string;
};

/**
 * Returns the Search component used in the search page.
 * @param {AdvancedSearchBarType} props the component props.
 * @returns {Function} the functional component
 **/
var AdvancedSearchBar = function AdvancedSearchBar(props) {
  return _react2.default.createElement(
    'div',
    { id: _style2.default.AdvancedSearchBar },
    _react2.default.createElement(
      'div',
      { className: [_style2.default.basicSearch, props.searchType !== APPOINTMENTS && _style2.default.scanInput].join(' ') },
      props.searchType === APPOINTMENTS && _react2.default.createElement(
        'div',
        { className: _style2.default.insurerBar + ' ' + _style2.default.basicSearchItem },
        _react2.default.createElement(_dropdown.Dropdown, {
          className: _style2.default.dropdownWithLogo,
          items: props.insurerItems,
          onItemSelected: props.onInsurerSelected,
          selectedItem: props.selectedInsurer,
          placeholder: 'Hospital List',
          readonly: 'true',
          ContentRenderer: function ContentRenderer() {
            return _react2.default.createElement(
              'div',
              { className: '' + _style2.default.dropdownContentRenderer },
              _react2.default.createElement('i', { className: 'ion-ios-paper-outline' }),
              _react2.default.createElement('i', { className: 'ion-android-arrow-dropdown' })
            );
          },
          ItemRenderer: function ItemRenderer(rendererProps) {
            var item = rendererProps.item,
                nameTransform = rendererProps.nameTransform;

            return _react2.default.createElement(
              'div',
              { className: '' + _style2.default.dropdownItem },
              _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
              _react2.default.createElement(
                'span',
                null,
                nameTransform(item)
              )
            );
          },
          ref: function ref(elem) {
            if (elem && (!props.page.insurersDropdownElem || props.page.insurersDropdownElem !== elem)) {
              props.pageActions.updateInsurersDropdownElem(elem);
            }
          },
          hint: 'You should only go to a hospital on your chosen list, as you\'re only covered for treatment at those hospitals. If you decide to go to a hospital that\'s not on your list, then you\'ll have to pay 40% of the costs of your treatment (excluding your specialist\'s fees). It is important that you check that the hospital your specialist suggests you attend is eligible under your plan. If you are on the Consultant Select product, please choose this from the Hospital List drop-down menu.'
        })
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.keywordBar + ' ' + _style2.default.basicSearchItem },
        _react2.default.createElement(_dropdown.Dropdown, {
          className: _style2.default.dropdownWithLogo,
          open: props.isKeywordDropdownOpen,
          items: props.keywordItems,
          placeholder: props.searchType === APPOINTMENTS && 'Type in a speciality, condition, procedure, name...' || 'What would you like to book?',
          selectedItem: props.selectedKeyword,
          onItemSelected: props.onKeywordSelected,
          onTextChanged: props.onKeywordTextChanged,
          itemDisplayNameTransform: function itemDisplayNameTransform(item) {
            return item.name;
          },
          itemChildrenTransform: function itemChildrenTransform(item) {
            return item.children;
          },
          ContentRenderer: function ContentRenderer() {
            return _react2.default.createElement(
              'div',
              { className: '' + _style2.default.dropdownContentRenderer },
              _react2.default.createElement('i', { className: props.searchType === HEALTH_CHECKS && 'ion-ios-heart-outline' || props.searchType === SCANS && 'ion-qr-scanner input-icon' || 'ion-ios-pulse' }),
              _react2.default.createElement('i', { className: 'ion-android-arrow-dropdown' })
            );
          },
          SectionHeaderRenderer: function SectionHeaderRenderer(rendererProps) {
            var item = rendererProps.item,
                nameTransform = rendererProps.nameTransform;

            return _react2.default.createElement(
              'div',
              { className: _style2.default.itemHeader },
              _react2.default.createElement(
                'span',
                null,
                nameTransform(item)
              )
            );
          },
          ItemRenderer: function ItemRenderer(rendererProps) {
            var item = rendererProps.item,
                nameTransform = rendererProps.nameTransform,
                childrenTransform = rendererProps.childrenTransform;

            if (item.renderAsProfile === true) {
              var profileImage = item.profile_image;

              var profileTopSpecialty = item.related_specialties && item.related_specialties.filter(function (specialty) {
                return specialty.parent_name === "abstract_top_level_keyword";
              })[0];
              profileTopSpecialty = profileTopSpecialty && props.listings.specialties.find(function (item) {
                return item.id === profileTopSpecialty.id;
              });

              return _react2.default.createElement(
                'div',
                { className: _style2.default.dropdownItem + ' ' + _style2.default.profileDropdownItem },
                profileImage && _react2.default.createElement('img', { src: profileImage, alt: nameTransform(item) }) || profileTopSpecialty && _react2.default.createElement(_specialtySvgIcon.SpecialtySvgIcon, { specialtyIconUri: profileTopSpecialty.icon_uri, className: _style2.default.specialtyIcon }),
                _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { className: _style2.default.profileName },
                    '' + nameTransform(item) + (item.networks && item.networks.length && '.' || '')
                  ),
                  profileTopSpecialty && _react2.default.createElement(
                    'span',
                    { className: _style2.default.profileSpecialty },
                    profileTopSpecialty.name
                  )
                ),
                _react2.default.createElement('i', { className: (childrenTransform(item) ? 'ion-ios-arrow-right' : '') + ' ' + _style2.default.parentIconDesktop }),
                _react2.default.createElement('i', { className: (childrenTransform(item) ? 'ion-ios-arrow-down' : '') + ' ' + _style2.default.parentIconMobile })
              );
            } else {
              var iconUri = item && (item.icon_uri || item.iconUri) || null;

              return _react2.default.createElement(
                'div',
                { className: '' + _style2.default.dropdownItem },
                iconUri && _react2.default.createElement(_specialtySvgIcon.SpecialtySvgIcon, {
                  className: _style2.default.specialtyIcon,
                  specialtyIconUri: item.icon_uri
                }) || _react2.default.createElement('span', { className: _style2.default.imagePlaceholder }),
                _react2.default.createElement(
                  'span',
                  null,
                  nameTransform(item)
                ),
                _react2.default.createElement('i', { className: (childrenTransform(item) ? 'ion-ios-arrow-right' : '') + ' ' + _style2.default.parentIconDesktop }),
                _react2.default.createElement('i', { className: (childrenTransform(item) ? 'ion-ios-arrow-down' : '') + ' ' + _style2.default.parentIconMobile })
              );
            }
          },
          showExpandedDropdown: props.searchType === APPOINTMENTS && true || false,
          ref: function ref(elem) {
            if (elem && (!props.page.searchItemDropdownElem || props.page.searchItemDropdownElem !== elem)) {
              props.pageActions.updateSearchItemDropdownElem(elem);
            }
          }
        })
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.locationBar + ' ' + _style2.default.basicSearchItem },
        _react2.default.createElement(_dropdown.Dropdown, {
          className: _style2.default.dropdownWithLogo,
          items: props.locationItems,
          setInputField: props.setLocationInputField,
          inputField: props.locationInputField,
          selectedItem: props.usingNearMe ? null : props.selectedLocation,
          onItemSelected: props.onLocationSelected,
          onTextChanged: function onTextChanged(text) {
            if (text.length) {
              props.onLocationTextchanged(text);
            } else {
              props.resetLocation();
            }
          },
          open: props.isLocationDropdownOpen,
          onReceiveFocus: props.clearLocationNearMe,
          placeholder: props.usingNearMe && props.findingLocation && 'Finding Location' || props.usingNearMe && !props.findingLocation && 'Near Me' || 'Location',
          ContentRenderer: function ContentRenderer() {
            return _react2.default.createElement(
              'div',
              { className: '' + _style2.default.dropdownContentRenderer },
              _react2.default.createElement('i', { className: 'ion-ios-location-outline ' + (props.searchType === 'practice' ? _style2.default.blue : '') }),
              _react2.default.createElement('div', {
                className: (props.usingNearMe ? _style2.default.nearMeBackground : '') + ' ' + (props.findingLocation ? _style2.default.pulse : '') + ' ' + (props.searchType !== APPOINTMENTS ? _style2.default.backgroundBlue : '') }),
              _react2.default.createElement('i', {
                className: 'ion-pinpoint ' + (props.searchType === 'practice' ? _style2.default.blue : '') + ' ' + (props.usingNearMe ? _style2.default.white : '') + ' ' + (props.findingLocation ? _style2.default.pulse : ''),
                onClick: function onClick(event) {
                  if (props.usingNearMe) {
                    props.clearLocationNearMe();
                  } else {
                    props.getLocationNearMe();
                  }
                  event.stopPropagation();
                } })
            );
          },
          ItemRenderer: function ItemRenderer(rendererProps) {
            var item = rendererProps.item,
                nameTransform = rendererProps.nameTransform;

            return _react2.default.createElement(
              'div',
              { className: '' + _style2.default.dropdownItemNoIcon },
              _react2.default.createElement(
                'span',
                null,
                nameTransform(item)
              )
            );
          }
        })
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.searchButtonHolder + ' ' + _style2.default.basicSearchItem + ' ' + _style2.default.noMargin },
        _react2.default.createElement(
          'button',
          {
            className: [_style2.default.searchButton, props.searchType === APPOINTMENTS ? _style2.default.appointments : _style2.default.scans].join(' '),
            onClick: function onClick() {
              (0, _doctifyUtils.fireGTMevent)('search_button_appointment_click');
              props.onUpdateClicked();
            } },
          'Update'
        )
      )
    ),
    props.searchType === APPOINTMENTS && _react2.default.createElement(
      'div',
      { className: _style2.default.advancedOptions },
      _react2.default.createElement(
        'div',
        { className: _style2.default.advancedOptionsItem + ' ' + _style2.default.dateButtons },
        _react2.default.createElement(_searchButton.SearchButton, {
          name: 'Next 2 weeks',
          onClick: function onClick() {
            props.onTimeFrameSelected(timeFrameInterval('twoWeeks'), 'twoWeeks');
            (0, _doctifyUtils.fireGTMevent)('search_two_weeks_button_click');
          },
          isSelected: props.selectedTimeFrame === 'twoWeeks'
        })
      ),
      _react2.default.createElement(
        'div',
        { className: _style2.default.datePicker + ' ' + _style2.default.advancedOptionsItem },
        _react2.default.createElement(_reactDates.SingleDatePicker, {
          date: props.selectedDate,
          focused: props.isCalendarOpen,
          onFocusChange: props.onCalendarFocus,
          numberOfMonths: 1,
          hideKeyboardShortcutsPanel: true,
          showDefaultInputIcon: true,
          customInputIcon: _react2.default.createElement('i', { className: 'ion-ios-calendar-outline' }),
          keepOpenOnDateSelect: false,
          isOutsideRange: function isOutsideRange(day) {
            return !(0, _isInclusivelyAfterDay2.default)(day, (0, _moment2.default)().add(2, 'days')) || (0, _isInclusivelyAfterDay2.default)(day, (0, _moment2.default)().add(30, 'days'));
          } //we pull bmi slots for 30 days
          ,
          onDateChange: function onDateChange(date) {
            return props.onCalendarDateChange([date, new _moment2.default(date).add(1, 'day')]);
          },
          displayFormat: 'll'
        })
      ),
      _react2.default.createElement(_subBarDropdown.SubBarDropdown, {
        className: _style2.default.advancedOptionsItem,
        placeholder: 'Language',
        items: props.languageItems,
        icon: 'ion-ios-world-outline',
        selectedItem: props.selectedLanguage,
        onItemSelected: props.onLanguageSelected
      }),
      _react2.default.createElement(_subBarDropdown.SubBarDropdown, {
        className: _style2.default.advancedOptionsItem,
        icon: 'ion-radio-waves',
        items: props.withinItems,
        selectedItem: props.selectedWithin,
        onItemSelected: function onItemSelected(item) {
          props.onWithinSelected(item);
          (0, _doctifyUtils.fireGTMevent)('distance_dropdown_select', item.value);
        },
        placeholder: 'Choose search radius'
      }),
      _react2.default.createElement(_searchButton.SearchButton, { name: 'Male',
        className: _style2.default.advancedOptionsItem,
        iconClass: 'ion-male',
        onClick: function onClick() {
          props.onGenderSelected('male');
          (0, _doctifyUtils.fireGTMevent)('search_male_button_click');
        },
        isSelected: props.selectedGender === 'male' }),
      _react2.default.createElement(_searchButton.SearchButton, { name: 'Female',
        iconClass: 'ion-female',
        onClick: function onClick() {
          props.onGenderSelected('female');
          (0, _doctifyUtils.fireGTMevent)('search_female_button_click');
        },
        isSelected: props.selectedGender === 'female' }),
      _react2.default.createElement(_searchButton.SearchButton, { name: 'Video Consultation',
        onClick: function onClick() {
          props.onVideoConsultationSelected(!props.videoConsultation);
        },
        isSelected: props.videoConsultation }),
      _react2.default.createElement(_subBarDropdown.SubBarDropdown, {
        className: _style2.default.sortType + ' ' + _style2.default.advancedOptionsItem + ' pull-right',
        icon: 'ion-android-funnel',
        items: props.sortTypeItems,
        selectedItem: props.selectedSortType,
        onItemSelected: props.onSortTypeSelected
      }),
      _react2.default.createElement(
        'div',
        { className: _style2.default.resultCount },
        !props.loadingResults ? buildFoundResultsString(props) : 'Loading results ...'
      )
    )
  );
};

AdvancedSearchBar.propTypes = {
  keywordItems: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
  insurerItems: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
  locationItems: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
  languageItems: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
  withinItems: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
  sortTypeItems: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
  isCalendarOpen: require('react').PropTypes.any,
  onCalendarFocus: require('react').PropTypes.func,
  onCalendarDateChange: require('react').PropTypes.func,
  selectedLanguage: require('react').PropTypes.object,
  selectedLocation: require('react').PropTypes.object,
  selectedSortType: require('react').PropTypes.object,
  selectedDate: require('react').PropTypes.object,
  selectedKeyword: require('react').PropTypes.object,
  selectedInsurer: require('react').PropTypes.object,
  selectedWithin: require('react').PropTypes.object,
  selectedGender: require('react').PropTypes.any,
  videoConsultation: require('react').PropTypes.any,
  selectedTimeFrame: require('react').PropTypes.any,
  onTimeFrameSelected: require('react').PropTypes.func,
  onUpdateClicked: require('react').PropTypes.func,
  onKeywordSelected: require('react').PropTypes.func,
  onLocationSelected: require('react').PropTypes.func,
  resetLocation: require('react').PropTypes.func,
  onInsurerSelected: require('react').PropTypes.func,
  onSortTypeSelected: require('react').PropTypes.func,
  onWithinSelected: require('react').PropTypes.func,
  onGenderSelected: require('react').PropTypes.func,
  onVideoConsultationSelected: require('react').PropTypes.func,
  onLanguageSelected: require('react').PropTypes.func,
  onLocationTextchanged: require('react').PropTypes.func,
  onKeywordTextChanged: require('react').PropTypes.func,
  resultCount: require('react').PropTypes.any,
  loadingResults: require('react').PropTypes.any,
  isKeywordDropdownOpen: require('react').PropTypes.any,
  isLocationDropdownOpen: require('react').PropTypes.any,
  searchType: require('react').PropTypes.any,
  usingNearMe: require('react').PropTypes.any,
  findingLocation: require('react').PropTypes.any,
  clearLocationNearMe: require('react').PropTypes.func,
  getLocationNearMe: require('react').PropTypes.func,
  setLocationInputField: require('react').PropTypes.func.isRequired,
  locationInputField: require('react').PropTypes.any.isRequired
};
AdvancedSearchBar.defaultProps = {
  keywordItems: [],
  insurerItems: [],
  locationItems: [],
  languageItems: [],
  withinItems: [],
  sortTypeItems: [],
  loadingResults: false,
  resultCount: 0,
  isKeywordDropdownOpen: false,
  isLocationDropdownOpen: false,
  searchType: APPOINTMENTS,
  onTimeFrameSelected: function onTimeFrameSelected() {},
  onCalendarFocus: function onCalendarFocus() {},
  onCalendarDateChange: function onCalendarDateChange() {},
  onGenderSelected: function onGenderSelected() {},
  onUpdateClicked: function onUpdateClicked() {},
  onKeywordSelected: function onKeywordSelected() {},
  onLocationSelected: function onLocationSelected() {},
  onInsurerSelected: function onInsurerSelected() {},
  onSortTypeSelected: function onSortTypeSelected() {},
  onWithinSelected: function onWithinSelected() {},
  onLanguageSelected: function onLanguageSelected() {},
  onLocationTextchanged: function onLocationTextchanged() {},
  onKeywordTextChanged: function onKeywordTextChanged() {}
};

AdvancedSearchBar.displayName = 'AdvancedSearchBar';

exports.default = AdvancedSearchBar;


// WEBPACK FOOTER //
// ./components/advanced-search-bar/lib/components/advanced-search-bar.js